import script from "./workflowViewer.vue?vue&type=script&lang=js"
export * from "./workflowViewer.vue?vue&type=script&lang=js"

import "./workflowViewer.vue?vue&type=style&index=0&id=2704055a&lang=css"
import "./workflowViewer.vue?vue&type=style&index=1&id=2704055a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2704055a"]])

export default __exports__